module.exports = __webpack_public_path__ + "img/ASCPT2025.dcde09f9.jpg";